import { React } from '@gasbuddy/react';
import { Dwolla } from './Dwolla';
import { Daily } from './Daily';
import { Batch } from './Batch';
import { Monthly } from './Monthly';
import { Transaction } from './Transaction';
import { TransactionAuth } from './TransactionAuth';
import { Instrument } from './Instrument';
import { UsersPage } from '../identity/UsersPage';
import { Unbalanced } from './Unbalanced';
import { Coupons } from './Coupons';
import { Coupon } from './Coupon';
import { Wex } from './Wex';
import { WexMatcher } from './WexMatcher';
import { Location } from './Location';
import { BulkRerun } from './BulkRerun';
import { BulkBankDelete } from './BulkBankDelete';
import Cards from './Cards';
import { ManageGasBackCodes } from './ManageGasBackCodes';
import { ManualGasBack } from './ManualGasBack';
import { ReturnToSender } from './ReturnToSender';
import TransactionSearch from './TransactionSearch';
import InstrumentSearch from './InstrumentSearch';
import { UnprocessableBilling } from './UnprocessableBilling';

export const payments = {
  routes: [{
    component: Dwolla,
    path: '/dwolla',
    exact: true,
  }, {
    component: Daily,
    path: '/daily',
    exact: true,
  }, {
    component: Batch,
    path: '/batch',
    exact: true,
  }, {
    component: Daily,
    path: '/daily/:date',
    exact: true,
  }, {
    component: Batch,
    path: '/batch/:date',
    exact: true,
  }, {
    component: Monthly,
    path: '/monthly',
    exact: true,
  }, {
    component: Monthly,
    path: '/monthly/:date',
    exact: true,
  }, {
    component: Transaction,
    path: '/transaction/:account/:id',
    exact: true,
  }, {
    component: Unbalanced,
    path: '/unbalanced-transactions',
    exact: true,
  }, {
    component: Transaction,
    path: '/transaction/:id',
    exact: true,
  }, {
    component: Transaction,
    path: '/transaction/external/:counterparty/:id',
    exact: true,
  }, {
    component: TransactionAuth,
    path: '/transaction-auth/:account/:id',
    exact: true,
  }, {
    component: Instrument,
    path: '/instrument-map/:mapid',
    exact: true,
  }, {
    component: Coupons,
    path: '/coupons',
    exact: true,
  }, {
    component: Coupon,
    path: '/coupons/:couponId',
    exact: true,
  }, {
    component: () => <UsersPage url="/payments/cards/inactive" />,
    path: '/accounts/inactive',
    exact: true,
  }, {
    component: Wex,
    path: '/wex',
    exact: true,
  }, {
    component: BulkRerun,
    path: '/transactions/rerun',
    exact: true,
  },
  {
    component: BulkBankDelete,
    path: '/instruments/rerun',
    exact: true,
  },
  {
    component: Location,
    path: '/location/:poiId',
    exact: true,
  }, {
    component: TransactionSearch,
    path: '/transactions/search/:accountId?',
    exact: true,
  }, {
    component: InstrumentSearch,
    path: '/instruments/search',
    exact: true,
  }, {
    component: WexMatcher,
    path: '/wex-matcher',
  },
  {
    component: Cards,
    path: '/cards',
  }, {
    component: ManageGasBackCodes,
    path: '/gasback/codes',
    exact: true,
  }, {
    component: ManualGasBack,
    path: '/gasback/redemptions',
    exact: true,
  }, {
    component: ReturnToSender,
    path: '/return-to-sender',
    exact: true,
  }, {
    component: UnprocessableBilling,
    path: '/unprocessable-billing',
    exact: true,
  }],
};
